import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { defaultDateFormat } from 'Common/GeneralHelper';
import { Filter, Main } from 'Containers/';
import { LoadingPage, TitledCard } from 'Components/';
import SelectSitesTable from 'Common/SelectSitesTable';
import { ReportGeneration } from 'Common/ObjectHelper';
import { toastType, createToast, toastError } from 'Common/ToastHelper';
import { StatusChangeReportForm } from './components/StatusChangeForm';
import { STATUS_CHANGE_REPORT_FORM_NAME } from 'Common/FormEnum';
import { StatusChangeReportFieldEnum as Fields } from 'Common/FieldEnum';
import {
  getStatusChangeReport,
  clearReport,
  setSelectedSites,
  clearErrors,
} from './state/report/actions';
import { getControlInfo } from 'State/controlInfo/actions';

export class StatusChangeReportContainer extends Component {
  handleSubmit = (formValues) => {
    if (this.props.selectedSites && this.props.selectedSites.length === 0) {
      toastError('You must select at least one site.');
      return;
    }
    if (
      formValues.FilterAdded === false &&
      formValues.FilterChanged === false &&
      formValues.FilterWithdrawn === false
    ) {
      toastError('You must select at least one filter.');
      return;
    }
    // The Form and sites table are seperate, so they are combined into one object
    const values = { ...formValues, selectedSites: this.props.selectedSites };
    this.props.getStatusChangeReport(values);
  };

  onSiteChange = (selectedSites) => {
    this.props.setSelectedSites(selectedSites);
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: STATUS_CHANGE_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getControlInfo();
  }

  componentDidUpdate(prevProps, prevState) {
    const { report, loadError } = this.props;
    if (report && prevProps.report !== report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Status Change Report');
      }
      this.props.clearReport();
    }
    if (loadError && prevProps.loadError !== loadError) {
      toastError(loadError);
    }
    this.props.clearErrors();
  }

  render() {
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Status Change Report'} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Filters'}>
            <StatusChangeReportForm
              onSubmit={this.handleSubmit}
              initialValues={{
                [Fields.FromDate]: defaultDateFormat(moment()),
                [Fields.ToDate]: defaultDateFormat(moment()),
                [Fields.AsOfDate]: 0,
                [Fields.ProvisionType]: this.props.provisionType,
                [Fields.SortBy]: 0,
                [Fields.FilterAdded]: false,
                [Fields.FilterChanged]: false,
                [Fields.FilterWithdrawn]: false,
                [Fields.PrintSSN]: false,
              }}
            />
          </TitledCard>
          <TitledCard title={'Sites'}>
            <SelectSitesTable
              onChange={this.onSiteChange}
              fetchAllSites={true}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { statusChange } = state.StatusChangeState;
  // state
  return {
    loading: statusChange.loading,
    report: statusChange.report,
    selectedSites: statusChange.selectedSites,
    loadError: statusChange.loadError,
    provisionType: state.CommonState.controlInfo.data.ProvisionTypeDefault,
  };
};

export const StatusChange = withRouter(
  connect(mapStateToProps, {
    getStatusChangeReport,
    clearReport,
    setSelectedSites,
    clearErrors,
    getControlInfo,
  })(StatusChangeReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/statuschange/StatusChange.js